export enum AppPathEnum {
    ALUMNI_VOLUNTEERING = "/alumnivolunteering",
    DONATION_DASHBOARD = "/donation-dashboard",
    DONATION_REGION = "/donation/:region",
    DONATION_IRELAND = `/donation/IRELAND`,
    DONATION_USA = `/donation/USA`,
    DONATION_UK = `/donation/UK`,
    PCS_EVENT_APPROVAL = "/pcseventapproval",
    PCS_PLAN_REVIEW = "/pcsplanreview",
    PCS_VIEW_CPDS = "/pcsviewcpds",
    PCS_VIEW_CPD = "/pcsviewcpd",
    PCS_VIEW_CPD_CREDIT_RECORD_ID = '/pcsviewcpd/:creditRecordId',
    PCS_ADD_CPD = "/pcsaddcpd",
    PCS_UPDATE_CPD_CREDIT_RECORD = "/pcsupdatecpd",
    PCS_UPDATE_CPD_CREDIT_RECORD_ID = "/pcsupdatecpd/:creditRecordId",
    PCS_CLONE_CPD_CREDIT_RECORD = "/pcsclonecpd",
    PCS_CLONE_CPD_CREDIT_RECORD_ID = "/pcsclonecpd/:creditRecordId",
    PCS_RE_ENROLL = "/pcsreenrolment",
    PCS_SUMMARY = "/pcssummary",
    PCS_PLAN = "/pcsplan",
    PCS_REVIEWER_DETAILS = "/pcsReviewerDetails",
    PCS_REVIEWER_DETAILS_ENROLMENT_YEAR_ID = "/pcsReviewerDetails/:enrolmentYearId",
    PCS_PLAN_DETAILS_ENROLMENT_YEAR_ID = "/pcsplandetails/:enrolmentYearId",
    PCS_PLAN_DETAILS = "/pcsplandetails",
    PCS_PLAN_REVIEWER_DETAILS = "/pcsplan-reviewer-details",
    PCS_PLAN_REVIEWER_DETAILS_ENROLMENT_YEAR_ID = "/pcsplan-reviewer-details/:enrolmentYearId",
    PCS_PLAN_FEEDBACK_ENROLMENT = "/pcsplanfeedback",
    PCS_PLAN_FEEDBACK_ENROLMENT_YEAR_ID = "/pcsplanfeedback/:enrolmentYearId",
    PCS_ENROLMENT = "/pcsenrolment",
    MEMBERSHIP_ONBOARDING = "/membershiponboarding",
    MEMBERSHIP_TRANSFER = "/membershiptransfer",
    AFFILIATE_ASSOCIATE = "/affiliateassociate",
    MEMBERSHIP_VOLUNTEERING = "/membershipvolunteering",
    MEMBERSHIP_RENEWAL = "/membershiprenewal",
    UPDATE_PROFILE = "/updateprofile",
    MY_RECEIPTS = "/myreceipts",
    MY_DOCUMENTS = "/mydocuments",
    ACCESS_REQUEST = "/accessrequest",
    REQUEST = "/request",
    DONATIONS_DIRECT_DEBIT = "/donation-direct-debit",
    MEMBERSHIP_DIRECT_DEBIT = "/membership-direct-debit",
    MANAGE_DIRECT_DEBIT_BY_ID = "/manage-direct-debit/:directDebitId",
    MANAGE_DIRECT_DEBIT = "/manage-direct-debit",
    MEMBER_IN_GOOD_STANDING = "/member-in-good-standing",
    PREPAID_PAYMENT_SUCCESS_URI = "/prepaid-payment-success",
    PAYMENT_SUCCESS_URI = "/payment-success",
    PCS_ENROLMENT_PAYMENT_SUCCEED = "/pcs-enrolment-payment-success",
    DONATION_PAYMENT_SUCCESS_URI = "/donation-payment-success",
    EVENT_SUBMIT_SUCCESS_URI = "/event-submit-success",
    RequestPortalAccess = "/request-portal-access",
    Reductions_And_Exemptions = "/reductions-and-exemptions",
    MERCHANDISE = "/merchandise",
    LINKEDIN = "/linkedIn",
    PASTEST = "/pastest",
    CLASS_NOTES = "/class-notes",
    TOURS = "/tours",
    CONTACT_CLASSMATES = "/contact-classmate",
    YEAR_BOOK = "/year-book",
    ACCESS_CARD_ALUMNI = "/access-card-alumni",
    ACCESS_CARD_FELLOW_AND_MEMBER = "/access-card-fellow-and-member",
    ABSENCE_FROM_PRACTICE_PCS = "/absence-from-practice-pcs",
    REQUEST_TO_WITHDRAW_PCS = "/request-to-withdraw-pcs",
    VOLUNTEER_REQUEST = "/volunteer-request",
    CHANGE_OF_NAME = "/change-name",
    PCS_EVENT_DETAILS = "/pcs-event-details",
    PCS_CALENDAR_OF_ACTIVITIES_DETAILS = "/pcs-calendar-of-activities/:instanceId",
    PCS_CALENDAR_OF_ACTIVITIES = "/pcs-calendar-of-activities",
    PCS_EVENT_APPLICANT_PERSONAL_DETAILS = "/pcs-event-applicant-personal-details"
}
